import { isString } from 'lodash';

export const SET_ACTION_BUTTON_PROPERTIES = 'SET_ACTION_BUTTON_PROPERTIES';
export const ACTION_BUTTON_OPEN_MODAL = 'ACTION_BUTTON_OPEN_MODAL';
export const ACTION_BUTTON_CLOSE_MODAL = 'ACTION_BUTTON_CLOSE_MODAL';

export function buildActionButtonProperty(label, path, kind){
    if(!isString(label)){
        throw new TypeError('label parameter must be a string');
    }
    if(!isString(path)){
        throw new TypeError('path parameter must be a string');
    }

    return {
        label,
        path,
        kind,
    };
}

export function setActionButton(properties){
    return {
        type: SET_ACTION_BUTTON_PROPERTIES,
        payload: properties
    };
}

export function clearActionButton(){
    return {
        type: SET_ACTION_BUTTON_PROPERTIES,
        payload: null,
    };
}

export function openModal(modalName) {
    return {
        type: ACTION_BUTTON_OPEN_MODAL,
        payload: modalName,
    };
}

export function closeModal(modalName) {
    return {
        type: ACTION_BUTTON_CLOSE_MODAL,
        payload: modalName,
    };
}